import { Button } from '#/components/ui/button';
import type { ComponentProps } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { DATA_AREAS } from '~/constants/data-areas';

type LoginButtonProps = Omit<ComponentProps<typeof Button>, 'onClick'> & {
  onClick?: () => void;
};

export function LoginButton({ children = 'ログイン', onClick, ...props }: LoginButtonProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogin = () => {
    // 親コンポーネントから渡されたonClickを実行
    if (onClick) {
      onClick();
    }
    // 環境変数からログインURLを取得
    const loginUrl = import.meta.env.VITE_LOGIN_URL;

    if (loginUrl) {
      // 現在のパスをクエリパラメータとして追加
      let url: URL;

      // 外部URLの場合
      if (loginUrl.startsWith('http://') || loginUrl.startsWith('https://')) {
        url = new URL(loginUrl);
        url.searchParams.set('transitionPath', location.pathname);
        window.location.href = url.toString();
      } else {
        // 内部パス(通常は/dev-login)の場合
        url = new URL(loginUrl, window.location.origin);
        url.searchParams.set('transition_path', location.pathname);
        navigate(url.pathname + url.search);
      }
    }
  };

  return (
    <Button onClick={handleLogin} {...props} data-area={DATA_AREAS.SITE_LOGIN_BUTTON}>
      {children}
    </Button>
  );
}
